import {BaseModel} from "../base-model";

export enum DeviceType {
  MOBILE, // NoAR
  MR_MOBILE, // AR
  HOLOLENS, // AR
}

export enum VideocallProvider {
  JITSI,
  BYN,
}

export class VideocallStatus extends BaseModel {

  protected static self = VideocallStatus;

  eventId: number;
  deviceType: DeviceType;
  isDeviceReady: boolean;
  videocallProvider: VideocallProvider;

  get deviceTypeAsString() {
    return VideocallStatus.DeviceTypeAsString(this.deviceType);
  }

  get videocallProviderAsString() {
    return VideocallStatus.VideocallProviderAsString(this.videocallProvider);
  }

  public static DeviceTypeAsString(deviceType: DeviceType) {
    return DeviceType[deviceType].toLowerCase();
  }

  public static VideocallProviderAsString(videocallProvider: VideocallProvider) {
    return (videocallProvider == VideocallProvider.JITSI ? 'wv' : '') +  VideocallProvider[videocallProvider].toLowerCase();
  }

  public static fromFlux(json: object) {
    const status = new VideocallStatus();
    status.eventId = json['event_id'];
    status.deviceType = parseInt(json['device_type']);
    status.isDeviceReady = json['is_device_ready'];
    status.videocallProvider = parseInt(json['provider_type']);
    return status;
  }

}
